import { render, staticRenderFns } from "./ossUploader.vue?vue&type=template&id=2eb6857e"
import script from "./ossUploader.vue?vue&type=script&lang=js"
export * from "./ossUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports